module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"reduxActions","commonjs2":"redux-actions","commonjs":"redux-actions","amd":"redux-actions","umd":"redux-actions"}
// module id = 1
// module chunks = 0